export interface ExtrinsicCostEstimate {
  partialFee: string;
  estimatedFeeInTokens: string;
  weight: string;
  length: number;
}
